export const COACH_TAB_KEYS = [
  "dashboard",
  "clients",
  "groups",
  "programs",
  "tests",
  "messages",
];

export const COACH_TAB_LABELS = {
  dashboard: "Tableau de bord",
  clients: "Clients",
  groups: "Groupes",
  programs: "Programmes",
  tests: "Tests physiques",
  messages: "Messagerie",
};

export const DEFAULT_COACH_TAB_PERMISSIONS = [...COACH_TAB_KEYS];

export const normalizeCoachPermissions = (value, isAdmin = false) => {
  if (isAdmin) return [...COACH_TAB_KEYS];
  if (!Array.isArray(value)) return [...DEFAULT_COACH_TAB_PERMISSIONS];

  const allowed = new Set(COACH_TAB_KEYS);
  const normalized = value
    .map((entry) => String(entry || "").trim())
    .filter((entry) => allowed.has(entry));

  return normalized.length
    ? Array.from(new Set(normalized))
    : [...DEFAULT_COACH_TAB_PERMISSIONS];
};

export const hasCoachFeature = (coach, feature) => {
  if (!feature) return true;
  if (coach?.is_admin) return true;
  const permissions = normalizeCoachPermissions(coach?.coach_permissions, false);
  return permissions.includes(feature);
};

export const getDefaultCoachRoute = (coach) => {
  if (!coach) return "/login";
  if (coach.is_admin || hasCoachFeature(coach, "dashboard")) return "/";
  if (hasCoachFeature(coach, "clients")) return "/clients";
  if (hasCoachFeature(coach, "groups")) return "/groups";
  if (hasCoachFeature(coach, "programs")) return "/programs";
  if (hasCoachFeature(coach, "tests")) return "/tests";
  if (hasCoachFeature(coach, "messages")) return "/messages";
  return "/settings";
};
